/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoUpdateVoyageInput = {
    clientMutationId?: string | null;
    slug: string;
    name: string;
    vesselSlug: string;
    sourcePortCode: string;
    destinationPortCode: string;
    shouldFetchEta: boolean;
    etd?: string | null;
    eta?: string | null;
};
export type VoyageEditMutationVariables = {
    input: infoUpdateVoyageInput;
};
export type VoyageEditMutationResponse = {
    readonly infoUpdateVoyage: {
        readonly voyage: {
            readonly slug: string;
        };
    } | null;
};
export type VoyageEditMutation = {
    readonly response: VoyageEditMutationResponse;
    readonly variables: VoyageEditMutationVariables;
};



/*
mutation VoyageEditMutation(
  $input: infoUpdateVoyageInput!
) {
  infoUpdateVoyage(input: $input) {
    voyage {
      slug
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VoyageEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoUpdateVoyagePayload",
        "kind": "LinkedField",
        "name": "infoUpdateVoyage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Voyage",
            "kind": "LinkedField",
            "name": "voyage",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VoyageEditMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoUpdateVoyagePayload",
        "kind": "LinkedField",
        "name": "infoUpdateVoyage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Voyage",
            "kind": "LinkedField",
            "name": "voyage",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "862210474282f4b9e7e4bc47b1b02c9a",
    "id": null,
    "metadata": {},
    "name": "VoyageEditMutation",
    "operationKind": "mutation",
    "text": "mutation VoyageEditMutation(\n  $input: infoUpdateVoyageInput!\n) {\n  infoUpdateVoyage(input: $input) {\n    voyage {\n      slug\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'c873255b81128a81730f81ac78e81897';
export default node;
